import { Navigate, Outlet } from "react-router-dom";

export const VerifiedEmail = ({ isVerified = false }) => {
  return isVerified ? <Outlet /> : <Navigate replace to="./verify-email" />;
};
export default VerifiedEmail;
